module.exports = __webpack_public_path__ + "static/media/christina4.b44cfe89.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/wedo/christina4.png
// module id = 157
// module chunks = 0